// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_33974c2b58--tooltip--Jsh1z","arrow_tooltip":"_33974c2b58--arrow_tooltip--SRU9V","arrow":"_33974c2b58--arrow--A4pue"};